/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DownSavingTransactionSumReport = {
    shopPaymentChannelId: string;
    paymentChannelType?: DownSavingTransactionSumReport.paymentChannelType;
    direction: DownSavingTransactionSumReport.direction;
    downSavingPaymentSum: number;
    downSavingPaymentCount: number;
    finePaymentSum: number;
    finePaymentCount: number;
    qrCodeObjectKey?: string;
    bankCode?: DownSavingTransactionSumReport.bankCode;
    accountName?: string;
    accountId?: string;
};
export namespace DownSavingTransactionSumReport {
    export enum paymentChannelType {
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        PROMPT_PAY_QR = 'PROMPT_PAY_QR',
        BANK_ACCOUNT = 'BANK_ACCOUNT',
        AUTOMATIC_QR = 'AUTOMATIC_QR',
        TRUE_WALLET = 'TRUE_WALLET',
        CHILLPAY_QR = 'CHILLPAY_QR',
    }
    export enum direction {
        DEPOSIT = 'DEPOSIT',
        WITHDRAW = 'WITHDRAW',
    }
    export enum bankCode {
        BBL = 'BBL',
        BAY = 'BAY',
        SCB = 'SCB',
        KBANK = 'KBANK',
        KTB = 'KTB',
        TTB = 'TTB',
    }
}

